import React from "react";
import { Menu, Dropdown, Button} from "antd";
import "./StatusByDropdownStyles/StatusByDropdownStyles.css";
import "antd/dist/antd.css";

function StatusByDropdown({ text, setText, defaultKey }) {
  const menu = (
    <Menu
      style={{ width: "100%", paddingTop: 0, paddingBottom: 0 }}
      selectable
      onClick={(e) => setText(e.key)}
      defaultSelectedKeys={defaultKey}
    >
      <Menu.Item key={"All"} className="h-100">
        <span className="dropdown-text-style">All</span>
      </Menu.Item>
      <Menu.Item key={"Processing"} className="h-100">
        <span className="dropdown-text-style">Processing</span>
      </Menu.Item>
      <Menu.Item key={"Completed"} className="h-100">
        <span className="dropdown-text-style">Completed</span>
      </Menu.Item>
      <Menu.Item key={"Failed"} className="h-100">
        <span className="dropdown-text-style">Failed</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown overlay={menu} placement="bottomCenter">
      <Button
        style={{
          paddingLeft: 0,
          paddingRight: 0,
        }}
        className="d-flex ant-btn-style"
      >
        <div className="row g-0 h-100 w-100 align-items-center">
          <div className="col-10 h-100 d-flex align-items-center justify-content-center right-border-style text-break">
            <span className="align-text-center justify-text-center ms-2 my-custom-input-text ms-1 me-1 text-wrap">
              {"Status by: " + text}
            </span>
          </div>
          <div className="col-2 h-100 d-flex justify-self-end align-items-center justify-content-center">
            <img src="https://d1swyfveypj49y.cloudfront.net/PortfolioArrow.svg" alt="portfolio-arrow"></img>
            {/* <span className="d-flex align-text-center text-end">
                              I
                            </span> */}
          </div>
        </div>
      </Button>
    </Dropdown>
  );
}
export default StatusByDropdown;
